import React from "react";
import {ReturnSellerFilter} from "./ReturnSellerFilter";
import {SectorFilter} from "./SectorFilter";
import {SellerBatchFilter} from "./SellerBatchFilter";
import {SellerTimeFilter} from "./SellerTimeFilter";
import {useSearchParams} from "react-router-dom";
import {ShippingSearchParamKey} from "features/shipping/types";

export const ShippingFilter = () => {
  const [params] = useSearchParams();
  
  return (<>
    <SellerTimeFilter
      timeStart={params.get(ShippingSearchParamKey.shippingTimeDiffMinutes)}
      timeEnd={params.get(ShippingSearchParamKey.shippingTimeDiffEndMinutes)}
      value={params.get(ShippingSearchParamKey.shippingShopUuids)}
    />
    <SellerBatchFilter
      value={params.get(ShippingSearchParamKey.pickupBatchUuids)}
    />
    <ReturnSellerFilter
      value={params.get(ShippingSearchParamKey.returnSellerUuids)}
    />
    <SectorFilter
      value={params.get(ShippingSearchParamKey.designatedSectorCodes)}
    />
  </>);
};
